// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.header-dealer-hours-section {
    max-width: 40%;
    min-width: 750px;
    background: #fff;
    height: 50vh !important;
    padding: 30px;
    font-size: 12px;
    overflow: hidden;
    position: absolute;
    right: -30px;
    top: 70px;
    box-shadow: -1px 1px 10px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.06);
    border-radius: 15px;
    z-index: 99;
    color: #333;
}
.dealer-hours-container {
    display: flex !important;
    gap: 20px;
    flex-wrap: wrap;
    overflow: scroll;
}
.department-hours {
    flex: 0 0 calc(33.3% - 20px);
    margin: 0 !important;
}
.header-dealer-hours-section .lightbackground2-primary {
    display: none !important;
}
.header-dealer-hours-section .dealer-icon h3 {
    font-size: 1rem !important;
}
.header-dealer-hours-section .current-day {
    font-size: 12px !important;
}
.header-dealer-hours-section .holiday-hours {
    flex: 0 0 calc(50% - 20px);
}
`, "",{"version":3,"sources":["webpack://./src/Components/DealerHours/DealerHours/HeaderDealerHours.vue"],"names":[],"mappings":";AA6BE;IACE,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,2EAA2E;IAC3E,mBAAmB;IACnB,WAAW;IACX,WAAW;AACb;AACA;IACE,wBAAwB;IACxB,SAAS;IACT,eAAe;IACf,gBAAgB;AAClB;AACA;IACE,4BAA4B;IAC5B,oBAAoB;AACtB;AACA;IACE,wBAAwB;AAC1B;AACA;IACE,0BAA0B;AAC5B;AACA;IACE,0BAA0B;AAC5B;AACA;IACE,0BAA0B;AAC5B","sourcesContent":["<!--\r\nImportant:\r\nThis Component is used only for the Vue3 application\r\nAny modifications made should be done for Vue2 component also\r\nVue2File:wwwroot\\js\\ParagonGroup\\components\\DealerHours\\HeaderDealerHours.vue\r\nDont forget to make the changes in both the files\r\nAny clarifications contact divya\r\n-->\r\n<template>\r\n  <div class=\"header-dealer-hours-section\">\r\n    <div class=\"text-right mr-2 mb-2\"><em class=\"primaryicon-times ft-12\" @click=\"closeHours()\" /></div>\r\n    <business-hours />\r\n  </div>\r\n</template>\r\n<script>\r\nimport businessHours from \"./ClassicFooterDealerHours.vue\";\r\nexport default {\r\n  components: {\r\n    businessHours\r\n  },\r\n  methods:{\r\n    closeHours() {\r\n      this.$emit('closehours');\r\n    },\r\n  }\r\n}\r\n</script>\r\n\r\n<style>\r\n  .header-dealer-hours-section {\r\n    max-width: 40%;\r\n    min-width: 750px;\r\n    background: #fff;\r\n    height: 50vh !important;\r\n    padding: 30px;\r\n    font-size: 12px;\r\n    overflow: hidden;\r\n    position: absolute;\r\n    right: -30px;\r\n    top: 70px;\r\n    box-shadow: -1px 1px 10px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.06);\r\n    border-radius: 15px;\r\n    z-index: 99;\r\n    color: #333;\r\n  }\r\n  .dealer-hours-container {\r\n    display: flex !important;\r\n    gap: 20px;\r\n    flex-wrap: wrap;\r\n    overflow: scroll;\r\n  }\r\n  .department-hours {\r\n    flex: 0 0 calc(33.3% - 20px);\r\n    margin: 0 !important;\r\n  }\r\n  .header-dealer-hours-section .lightbackground2-primary {\r\n    display: none !important;\r\n  }\r\n  .header-dealer-hours-section .dealer-icon h3 {\r\n    font-size: 1rem !important;\r\n  }\r\n  .header-dealer-hours-section .current-day {\r\n    font-size: 12px !important;\r\n  }\r\n  .header-dealer-hours-section .holiday-hours {\r\n    flex: 0 0 calc(50% - 20px);\r\n  }\r\n</style>\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
